/* Generated by ./script/iconify.js */
/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import IconBase from './IconBase'
import classnames from 'classnames'

const IconDocumentDelete = ({ className, ...rest }) => {
  const classes = classnames(
    'icon',
    'icon--documentdelete',
    className,
  )

  return (
    <IconBase className={classes} viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg"{...rest}><path className="path1" fillRule="evenodd" clip-rule="evenodd" d="M10.5 1H14v2H0V1h3.5l1-1h5l1 1zM3 18c-1.1 0-2-.9-2-2V4h12v12c0 1.1-.9 2-2 2H3z" fill="#BDBDBD"/></IconBase>
  )
}

IconDocumentDelete.propTypes = {
  className: PropTypes.string,
}

export default IconDocumentDelete
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/icons/IconDocumentDelete.js